import script from "./RunningGameTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RunningGameTable.vue?vue&type=script&setup=true&lang=js"

import "./RunningGameTable.vue?vue&type=style&index=0&id=763deb1e&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-763deb1e"]])

export default __exports__